import {locationContainer, RenderingServices, utils} from '@wallaby-ui/core';

import {I18N} from './base_link_formatter_params';
import FilterParser from 'src/js/lib/filtering/filter_parser';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

export function getFilterStringWithReuseFilters(
  formatterParams,
  ownQueryParameters,
  filterString
) {
  const reuseFilters = formatterParams.getReuseFilter();
  const locationPath = formatterParams.getLocationPath();
  let newFilterString = filterString;
  if (
    reuseFilters &&
    locationPath &&
    ownQueryParameters[locationPath] &&
    ownQueryParameters[locationPath].filter
  ) {
    const filtersMap = FilterParser.fromStringAsMapOfLiterals(
      decodeURI(ownQueryParameters[locationPath].filter)
    );
    if (filtersMap) {
      reuseFilters.forEach((reuseFilter) => {
        const filterLiteral = filtersMap[reuseFilter];
        if (filterLiteral) {
          newFilterString = FilterParser.appendFilterLiteralToSerializedFilter(
            newFilterString,
            filterLiteral
          );
        }
      });
    }
  }
  return newFilterString;
}

export default function baseReportLinkFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {intl, store} = services;
  const {colDef, data, queryParameters, value} = params;

  const ownQueryParameters = store
    ? store.getState()[locationContainer.LOCATION_REDUCER_STATE_ID].parameters
    : queryParameters;
  const inputData = data;

  const formatterParams = new CellRendererParams(
    colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
  );
  const route = formatterParams.getRoute();
  const filterName = formatterParams.getFilterName();
  let label = formatterParams.getLabelColumn()
    ? inputData[formatterParams.getLabelColumn()]
    : value;
  const link = formatterParams.getLinkColumn()
    ? inputData[formatterParams.getLinkColumn()]
    : value;

  label = intl ? utils.TranslateUtils.translate(label, intl) : label;
  const titleText = `${label} - ${
    intl ? utils.TranslateUtils.translate(I18N.OPEN_DETAIL, intl) : ''
  }`;

  let searchParams;
  if (link) {
    let filterString = `${filterName}:'${link}'`;

    // reuse filters - copy filter from current url if it is defined in the config
    filterString = getFilterStringWithReuseFilters(
      formatterParams,
      ownQueryParameters,
      filterString
    );

    searchParams = {filter: filterString};
  }

  return {...params, filterName, label, link, route, searchParams, titleText};
}
